// Navigation view per screen type (decision H0): tree (B) or path (C).
// Monitoring screens default to the path; the tree needs >= 1100 px.
import { signal } from "@preact/signals";

const KEY = "sentinel.navMode";
const read = (): Record<string, "tree" | "path"> => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };
export const navMode = signal(read());
export function setNavMode(kind: string, mode: "tree" | "path") {
  navMode.value = { ...navMode.value, [kind]: mode };
  try { localStorage.setItem(KEY, JSON.stringify(navMode.value)); } catch { /* storage blocked */ }
}
export const wide = () => typeof window !== "undefined" && window.innerWidth >= 1100;
